import { useEffect, useRef } from 'react';

import { Alert } from '@bcp-nextgen-dx-component-factory/design-system';
import { useAlert } from '@hooks';
import { useServicesStore } from '@store';

interface InvalidDataAlertProps {
	description?: string;
}

export const InvalidDataAlert = ({ description }: InvalidDataAlertProps) => {
	const { isVisible } = useAlert('invalidData');
	const { errorMessage } = useServicesStore((state) => state.accountChallenge) || {};

	const alertRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (isVisible && alertRef.current) {
			alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}, [isVisible]);

	if (!isVisible) {
		return null;
	}

	return (
		<div ref={alertRef}>
			<Alert type="warning">
				<Alert.Description text={description || errorMessage || ''} />
			</Alert>
		</div>
	);
};
